import CircularProgress from "@mui/material/CircularProgress";
import React from "react";
import {useTranslation} from "react-i18next";

export default function Loader({visible}) {
  const {t} = useTranslation();

  if (!visible) return null;

  return (
    <div style={{position: 'absolute', left: '50%', top: '50%', zIndex: 999}}>
      <CircularProgress aria-label={t('loading')}/>
    </div>
  );
}
